// https://html.spec.whatwg.org/multipage/input.html#input.email.attrs.value.multiple
// regex used by email inputs
export const emailRegexPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
